var { isMobile } = require("./lib/breakpoints");
var { COLORS, makeTranslate, classify } = require("./lib/helpers");
var { yearFull, yearAbbrev } = require("./lib/helpers/formatDate");

console.clear();

var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min")
};

// var today = new Date().toLocaleDateString('en-US', {month: 'numeric', day: 'numeric', year: 'numeric'});
var today = LABELS.last_updated;

var recess_dates_senate = [
    { 'begin': '3/26/2020', 'end': '5/3/2020' }
    // { 'begin': '10/5/2020', 'end': '10/12/2020' }
];
var recess_dates_house = [
    { 'begin': '3/28/2020', 'end': '5/14/2020' }
];

var apMonths = [ "Jan.", "Feb.", "March", "April", "May", "June", "July", "Aug.", "Sept.", "Oct.", "Nov.", "Dec." ];

// Render a stacked column chart.
module.exports = function(config) {
  // Setup
  var labelColumn = "date";

  var aspectWidth = 16;
  var aspectHeight = 9;
  var valueGap = 6;

  var margins = {
    top: 5,
    right: 16,
    bottom: 20,
    left: 30
  };

  var ticksY = 5;
  var roundTicksFactor = 5;

  if (isMobile.matches) {
    aspectWidth = 4;
    aspectHeight = 3;
  }

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight =
    Math.ceil((config.width * aspectHeight) / aspectWidth) -
    margins.top -
    margins.bottom;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  var labels = config.data.map(d => d[labelColumn]);

  // Create D3 scale objects.
  var xScale = d3
    .scaleBand()
    .domain(labels)
    .range([0, chartWidth])
    .padding(0);

  var values = config.data.map(d => d.total);
  var floors = values.map(
    v => Math.floor(v / roundTicksFactor) * roundTicksFactor
  );
  var ceilings = values.map(
    v => Math.ceil(v / roundTicksFactor) * roundTicksFactor
  );

  var min = Math.min(...floors);
  // var max = Math.max(...ceilings);
  var max = Math.ceil(config.max / roundTicksFactor) * roundTicksFactor;

  if (min > 0) {
    min = 0;
  }

  var yScale = d3
    .scaleLinear()
    .domain([min, max])
    .rangeRound([chartHeight, 0]);

  var colorScale = d3
    .scaleOrdinal()
    .domain(
      config.data[0].values.map(d => d.name)
    )
    .range([COLORS.orange3, COLORS.orange5, COLORS.teal5, COLORS.teal4]);

  // Render the legend.
  var legend = containerElement
    .append("ul")
    .attr("class", "key")
    .selectAll("g")
    .data(colorScale.domain())
    .enter()
    .append("li")
    .attr("class", function(d, i) {
      return `key-item key-${i} ${classify(d)}`;
    });

  legend.append("b").style("background-color", d => colorScale(d));

  legend.append("label").text(d => d);

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  // Recession bars
  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", makeTranslate(margins.left, margins.top));

  // Create D3 axes.
  var xAxis = d3
    .axisBottom()
    .scale(xScale)
    .tickValues(["4/1/2020", "7/1/2020", "10/1/2020", "1/1/2021", "4/1/2021", "7/1/2021", "10/1/2021" ])
    .tickFormat(function(d, i) {
      var date_array = d.split("/");
      return apMonths[date_array[0]-1] + " \u2019" + date_array[2].substr(2,2);
    });

  var yAxis = d3
    .axisLeft()
    .scale(yScale)
    .ticks(ticksY)
    .tickFormat(d => d);

  // Render axes to chart.
  chartElement
    .append("g")
    .attr("class", "x axis")
    .attr("transform", makeTranslate(0, chartHeight))
    .call(xAxis);

  chartElement
    .append("g")
    .attr("class", "y axis")
    .call(yAxis);

  // Render grid to chart.
  var yAxisGrid = function() {
    return yAxis;
  };

  chartElement
    .append("g")
    .attr("class", "y grid")
    .call(
      yAxisGrid()
        .tickSize(-chartWidth, 0)
        .tickFormat("")
    );

  // Render bars to chart.
  var bars = chartElement
    .selectAll(".bars")
    .data(config.data)
    .enter()
    .append("g")
    .attr("class", "bar")
    .attr("transform", d => makeTranslate(xScale(d[labelColumn]), 0));

  bars
    .selectAll("rect")
    .data(d => d.values)
    .enter()
    .append("rect")
    .attr("y", d => d.y1 < d.y0 ? yScale(d.y0) : yScale(d.y1))
    .attr("width", xScale.bandwidth())
    .attr("height", d => Math.abs(yScale(d.y0) - yScale(d.y1)))
    .style("fill", d => colorScale(d.name))
    .attr("class", d => classify(d.name));

  /*
   * Recess bars
   */
  var chartDates = config.chamber == "house" ? recess_dates_house : recess_dates_senate;
  var recess = chartElement.insert('g','*')
    .attr('class', 'recess')
    .selectAll('rect')
    .data(chartDates)
    .enter()
      .append('rect')
      .attr('x', d => xScale(d['begin']))
      // .attr('width', d => 1)
      .attr('width', d => xScale(d['end']) - xScale(d['begin']))
      .attr('y', 0)
      .attr('height', chartHeight);

  chartDates.forEach(function(c) {
    chartElement.append('text')
      .attr('class', 'chart-label')
      .attr('x', function(){
        var dates = c;
        return xScale(dates.begin) + ((xScale(dates.end) - xScale(dates.begin)) / 2);
      })
      .attr('y', 20)
      .text('Recess');
  })

  // chartElement.append('text')
  //   .attr('class', 'chart-label')
  //   .attr('x', function(){
  //     var dates = chartDates[0];
  //     return xScale(dates.begin) + ((xScale(dates.end) - xScale(dates.begin)) / 2);
  //   })
  //   .attr('y', 20)
  //   .text('Recess');

  // New Congress line

  if (LABELS.new_congress) {
    var new_congress_dates = [
      { 'begin': '1/3/2021' }
    ];

    var newCongressLine = chartElement.insert('g','*')
      .attr('class', 'new')
      .selectAll('line')
      .data(new_congress_dates)
      .enter()
        .append('line')
        .attr("x1", d => xScale(d['begin']) )
        .attr("x2", d => xScale(d['begin']) )
        .attr("y1", chartHeight)
        .attr("y2", 0)
        .attr('class', 'new-line')

    chartElement.append('text')
        .attr('class', 'new-label')
        .attr('x', function(){
          var dates = new_congress_dates[0];
          // console.log(dates)
          return xScale(dates.begin) - 8;
        })
        .attr('y', 20)
        .text('New');
    chartElement.append('text')
        .attr('class', 'new-label')
        .attr('x', function(){
          var dates = new_congress_dates[0];
          return xScale(dates.begin) - 8;
        })
        .attr('y', 36)
        .text('Congress');
  }

  // Render 0 value line.
  if (min < 0) {
    chartElement
      .append("line")
      .attr("class", "zero-line")
      .attr("x1", 0)
      .attr("x2", chartWidth)
      .attr("y1", yScale(0))
      .attr("y2", yScale(0));
  }

  // Render values to chart.
  // bars
  //   .selectAll("text")
  //   .data(function(d) {
  //     return d.values;
  //   })
  //   .enter()
  //   .append("text")
  //   .text(d => d.val)
  //   .attr("class", d => classify(d.name))
  //   .attr("x", xScale.bandwidth() / 2)
  //   .attr("y", function(d) {
  //     var textHeight = this.getBBox().height;
  //     var barHeight = Math.abs(yScale(d.y0) - yScale(d.y1));

  //     if (textHeight + valueGap * 2 > barHeight) {
  //       d3.select(this).classed("hidden", true);
  //     }

  //     var barCenter = yScale(d.y1) + (yScale(d.y0) - yScale(d.y1)) / 2;

  //     return barCenter + textHeight / 2;
  //   })
  //   .attr("text-anchor", "middle");
};
